import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import {
  FaTachometerAlt,
  FaUserTie,
  FaMoneyBillWave,
  FaUtensils,
  FaCheckCircle,
} from "react-icons/fa";

import editIcon from "../../assets/images/pms/Edit_icon.svg";
import { Pie, Bar, Line } from "react-chartjs-2";
import { Modal, Button, Form, Col, Row, Table } from "react-bootstrap";
import slip from "../../assets/images/slip.svg";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { billpunchbasicauth } from "../../utils/Credentials";
import { uniqueID } from "../../utils/utilFuctions";
import swal from "sweetalert";
import Select from "react-select";
import { Link } from "react-router-dom";
import { EmployecontracteeditModal, EmployeeModal, Viewmodalcontractpayslip } from "../Modal";
const sideNavItems = [
  { name: "Dashboard", key: "dashboard", icon: <FaTachometerAlt /> },
  { name: "Restaurant", key: "restaurant", icon: <FaUtensils /> },
  { name: "Employee", key: "employee", icon: <FaUserTie /> },
  { name: "Payroll", key: "payroll", icon: <FaMoneyBillWave /> },
];

const Contracthr = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [hoveredKey, setHoveredKey] = useState(null);

  const renderTabContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardTab />;
      case "restaurant":
        return <RestaurantTab />;
      case "employee":
        return <EmployeeTab />;
      case "payroll":
        return <PayrollTab />;
      default:
        return <DashboardTab />;
    }
  };

  return (
    <div className="d-flex">
      <div
        style={{
          width: "70px",
          minHeight: "100vh",
          backgroundColor: "#212529",
          color: "white",
        }}
        className="p-2 text-center"
      >
        <ul className="list-unstyled mt-4">
          {sideNavItems.map((item) => {
            const isActive = activeTab === item.key;
            const isHovered = hoveredKey === item.key;

            return (
              <li
                key={item.key}
                onClick={() => setActiveTab(item.key)}
                onMouseEnter={() => setHoveredKey(item.key)}
                onMouseLeave={() => setHoveredKey(null)}
                style={{
                  cursor: "pointer",
                  fontSize: "1.4rem",
                  marginBottom: "1rem",
                  padding: "6px",
                  borderRadius: "8px",
                  backgroundColor: isActive
                    ? "#f8f9fa"
                    : isHovered
                    ? "#495057"
                    : "transparent",
                  color: isActive ? "#212529" : "#ffffff",
                  position: "relative",
                  transition: "all 0.3s ease",
                }}
              >
                {item.icon}
                {isHovered && (
                  <span
                    style={{
                      position: "absolute",
                      left: "90px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "#343a40",
                      color: "#fff",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      whiteSpace: "nowrap",
                      fontSize: "0.8rem",
                      zIndex: 1,
                    }}
                  >
                    {item.name}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="flex-grow-1 p-4 mt-3 " style={{height:"85vh", overflow:"auto", scrollbarWidth:"none"}}>{renderTabContent()}</div>
   
    </div>
  );
};
const RestaurantTab = () => {
  const [showModal, setShowModal] = useState(false);

  const handleSaveVenue = (data) => {
    console.log("Venue data saved:", data);
  };
  const [shopData, setShopData] = useState([]);
  const { user } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const fetchShopData = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setShopData(data.data);
      } else {
        console.error("Failed to fetch shop data", data);
      }
    } catch (error) {
      console.error("Error fetching shop data:", error);
    }
  };

  useEffect(() => {
    fetchShopData();
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h5 style={{ margin: 0 }}>Restaurant Management</h5>
        <Button variant="success" size="sm" onClick={() => setShowModal(true)}>
          Add Venue
        </Button>
      </div>
      <ShopTable shopData={shopData} />
      <AddVenueModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onSave={handleSaveVenue}
        fetchShopData={fetchShopData}
      />
    </div>
  );
};
export const AddVenueModal = ({ show, handleClose, onSave, fetchShopData }) => {
  const [formData, setFormData] = useState({
    shop_name: "",
    shop_location: "",
    shop_mobile: "",
    shop_pincode: "",
    owner_name: "",
    owner_mobile: "",
    shop_gst: "",
    shop_type: "",
    shop_details: "",
  });

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const validateForm = () => {
    const errors = {};
    const requiredFields = {
      shop_name: "Shop name is required",
      shop_location: "Shop location is required",
      shop_mobile: "Shop mobile is required",
      shop_pincode: "Shop pincode is required",
      owner_name: "Owner name is required",
      owner_mobile: "Owner mobile is required",
      shop_gst: "GST number is required",
      shop_type: "Shop type is required",
      shop_details: "Shop details are required",
    };

    for (const field in requiredFields) {
      if (!formData[field]?.trim()) {
        errors[field] = requiredFields[field];
      }
    }
    const mobileRegex = /^[6-9]\d{9}$/;

    if (formData.shop_mobile && !mobileRegex.test(formData.shop_mobile)) {
      errors.shop_mobile = "Enter valid 10-digit shop mobile number";
    }

    if (formData.owner_mobile && !mobileRegex.test(formData.owner_mobile)) {
      errors.owner_mobile = "Enter valid 10-digit owner mobile number";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const raw = JSON.stringify({
        ...formData,
        firmid: user.firm_id,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/AddShopDetails`,
        requestOptions
      );
      const data = await res.json();

      if (
        data.status === "0" &&
        Array.isArray(data.result) &&
        data.result[0]?.result === "Y"
      ) {
        swal(
          "Success",
          data.result[0].message || "Venue added successfully",
          "success"
        );
        onSave?.(formData);
        handleClose();
        fetchShopData();
        setFormData({
          shop_name: "",
          shop_location: "",
          shop_mobile: "",
          shop_pincode: "",
          owner_name: "",
          owner_mobile: "",
          shop_gst: "",
          shop_type: "",
          shop_details: "",
        });
      } else {
        swal(
          "Error",
          data.result?.[0]?.message || data.msg || "Failed to save venue.",
          "error"
        );
      }
    } catch (error) {
      swal("Error", "Something went wrong while saving venue.", "error");
      console.error("API Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  return (
    <Modal show={show} onHide={handleClose} className="venuemodal">
      <Modal.Header closeButton>
        <Modal.Title>Add New Venue</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <div className="row pt-0">
            <Form.Group className=" col-md-6 px-1" controlId="shop_name">
              <Form.Label>Shop Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop name"
                name="shop_name"
                value={formData.shop_name}
                onChange={handleChange}
              />
              {formErrors.shop_name && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_name}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="owner_name">
              <Form.Label>Owner Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter owner name"
                name="owner_name"
                value={formData.owner_name}
                onChange={handleChange}
              />
              {formErrors.owner_name && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.owner_name}
                </p>
              )}
            </Form.Group>
          </div>

          <div className="row">
            <Form.Group className=" col-md-6 px-1" controlId="shop_mobile">
              <Form.Label>Shop Mobile</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter shop mobile"
                name="shop_mobile"
                value={formData.shop_mobile}
                onChange={handleChange}
              />
              {formErrors.shop_mobile && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_mobile}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="owner_mobile">
              <Form.Label>Owner Mobile</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter owner mobile"
                name="owner_mobile"
                value={formData.owner_mobile}
                onChange={handleChange}
              />
              {formErrors.owner_mobile && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.owner_mobile}
                </p>
              )}
            </Form.Group>
          </div>

          <div className="row">
            <Form.Group className=" col-md-6 px-1" controlId="shop_location">
              <Form.Label>Shop Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop location"
                name="shop_location"
                value={formData.shop_location}
                onChange={handleChange}
              />
              {formErrors.shop_location && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_location}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="shop_pincode">
              <Form.Label>Shop Pincode</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop pincode"
                name="shop_pincode"
                value={formData.shop_pincode}
                onChange={handleChange}
              />
              {formErrors.shop_pincode && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_pincode}
                </p>
              )}
            </Form.Group>
          </div>

          <div className="row">
            <Form.Group className=" col-md-6 px-1" controlId="shop_gst">
              <Form.Label>Shop GST</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter GST number"
                name="shop_gst"
                value={formData.shop_gst}
                onChange={handleChange}
              />
              {formErrors.shop_gst && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_gst}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="shop_type">
              <Form.Label>Shop Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop type"
                name="shop_type"
                value={formData.shop_type}
                onChange={handleChange}
              />
              {formErrors.shop_type && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_type}
                </p>
              )}
            </Form.Group>
          </div>

          <Form.Group className="mb-3" controlId="shop_details">
            <Form.Label>Shop Details</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter additional details"
              name="shop_details"
              value={formData.shop_details}
              onChange={handleChange}
            />
            {formErrors.shop_details && (
              <p style={{ color: "red", margin: "4px 0 0" }}>
                {formErrors.shop_details}
              </p>
            )}
          </Form.Group>

          <Button variant="primary" type="submit">
            Save Venue
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const GeneratePayrollModal = ({
  show,
  onHide,
  GetRestaurantTransaction,
  selectedMonth,  selectedYear,
}) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [shopData, setShopData] = useState([]);
  const [transactionLoaderState, setTransactionLoaderState] = useState(false);
  const { user } = useContext(GlobalContext);
  const [formData, setFormData] = useState({
    fk_empid: "",
    pay_days: "",
    from_date: "",
    to_date: "",
    amount: "",
    status: "P",
    firmid: user.firm_id,
    restaurant_id: "",
    month: "",
  });

  const { username, password } = billpunchbasicauth;
  const calculateDaysBetween = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 0;
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const diffTime = to - from;
    if (diffTime < 0) return 0;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };

  const fetchEmployeeData = async () => {
    try {
      const auth = btoa(`${username}:${password}`);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetContractEmployees`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await res.json();
      if (data.status === "0") setEmployeeData(data.data);
    } catch (err) {
      console.error("Error fetching employee data:", err);
    }
  };

  const fetchShopData = async () => {
    try {
      const auth = btoa(`${username}:${password}`);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await res.json();
      if (data.status === "0") setShopData(data.data);
    } catch (err) {
      console.error("Error fetching shop data:", err);
    }
  };

  useEffect(() => {
    if (show) {
      fetchEmployeeData();
      fetchShopData();
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const payDays = calculateDaysBetween(
        formData.from_date,
        formData.to_date
      );

      const payload = {
        ...formData,
        pay_days: payDays,
        amount: Number(formData.amount),
        month: Number(formData.month),
      };

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GenerateRestaurantSalary`,
        requestOptions
      );

      const data = await res.json();

      if (data.status === "0") {
        const successMessage =
          data.result && data.result.length > 0
            ? data.result[0].message
            : "Success";
        swal("Success", successMessage, "success");
        await GetRestaurantTransaction(selectedMonth, selectedYear);
      onHide();
      } else {
        swal("Error", data.msg || "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      swal("Error", "Something went wrong!", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Generate Payroll</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group controlId="fk_empid" className="mb-2">
                <Form.Label>Employee</Form.Label>
                <Form.Select
                  name="fk_empid"
                  value={formData.fk_empid}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Employee</option>
                  {employeeData.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="restaurant_id" className="mb-2">
                <Form.Label>Restaurant</Form.Label>
                <Form.Select
                  name="restaurant_id"
                  value={formData.restaurant_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Restaurant</option>
                  {shopData.map((shop) => (
                    <option key={shop.id} value={shop.id}>
                      {shop.shop_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="amount" className="mb-2">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="month" className="mb-2">
                <Form.Label>Month</Form.Label>
                <Form.Select
                  name="month"
                  value={formData.month}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Month</option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="from_date" className="mb-2">
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  name="from_date"
                  value={formData.from_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="to_date" className="mb-2">
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  name="to_date"
                  value={formData.to_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            disabled={transactionLoaderState}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={transactionLoaderState}
          >
            {transactionLoaderState ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

const DashboardTab = () => {
  const pieData = {
    labels: ["Active", "Inactive", "On Leave"],
    datasets: [
      {
        label: "Employee Status",
        data: [85, 25, 10],
        backgroundColor: ["#28a745", "#dc3545", "#ffc107"],
        borderWidth: 1,
      },
    ],
  };

  const barData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Monthly Payroll (₹ in K)",
        data: [45, 50, 48, 60, 55],
        backgroundColor: "#007bff",
        borderRadius: 5,
      },
    ],
  };

  const lineData = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "New Contracts",
        data: [12, 19, 7, 15],
        fill: false,
        borderColor: "#17a2b8",
        backgroundColor: "#17a2b8",
        tension: 0.3,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "bottom" },
      tooltip: { enabled: true },
    },
  };

  return (
    <div>
      <h4 className="mb-4">Dashboard Overview</h4>

      {/* Stats Cards */}
      <div className="row">
        <div className="col-md-4 mb-3">
          <div className="card text-white bg-primary">
            <div className="card-body">
              <h5 className="card-title">Total Employees</h5>
              <p className="card-text display-6">120</p>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card text-white bg-success">
            <div className="card-body">
              <h5 className="card-title">Active Contracts</h5>
              <p className="card-text display-6">95</p>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card text-white bg-warning">
            <div className="card-body">
              <h5 className="card-title">Pending Payrolls</h5>
              <p className="card-text display-6">12</p>
            </div>
          </div>
        </div>
      </div>

      {/* Charts */}
      <div className="row mt-4">
        {/* Pie Chart */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow-sm">
            <h5 className="text-center">Employee Status Overview</h5>
            <Pie data={pieData} options={chartOptions} />
          </div>
        </div>

        {/* Bar Chart */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow-sm">
            <h5 className="text-center">Payroll Trend (Last 5 Months)</h5>
            <Bar data={barData} options={chartOptions} />
          </div>
        </div>

        {/* Line Chart */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow-sm">
            <h5 className="text-center">New Contracts (Weekly)</h5>
            <Line data={lineData} options={chartOptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

const EmployeeTab = () => {
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const handleSaveEmployee = (data) => {
    console.log("Employee data saved:", data);
  };
  const [employeedata, setemployeedata] = useState([]);
  const { user } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const fetchemployeedata = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetContractEmployees`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setemployeedata(data.data);
      } else {
        console.error("Failed to fetch employee data", data);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    fetchemployeedata();
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h5 style={{ margin: 0 }}>Employee Management</h5>
        <Button
          variant="success"
          size="sm"
          onClick={() => setShowEmployeeModal(true)}
        >
          Add Employee
        </Button>
      </div>
      <Employeetable employeedata={employeedata}  Fetchemployeedata={fetchemployeedata}/>
      <AddEmployeeModal
        show={showEmployeeModal}
        handleClose={() => setShowEmployeeModal(false)}
        onSave={handleSaveEmployee}
        fetchemployeedata={fetchemployeedata}
      />
    </div>
  );
};
const PayrollTab = () => {
  const currentDate = new Date();

  const [showModal, setShowModal] = useState(false);
  const [payrolldata, setpayrolldata] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const GetRestaurantTransaction = async () => {
    setTransactionLoaderState(true);
    setpayrolldata([]);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantTransaction`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            month: selectedMonth.toString(),
            year: selectedYear.toString(),
            firmid: user.firm_id,
          }),
        }
      );

      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setpayrolldata(data.data);
      } else {
        console.error("Failed to fetch payroll data", data);
        setpayrolldata([]);
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error);
      setpayrolldata([]);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value));
  };

  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value));
  };

  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const yearOptions = Array.from(
    { length: 5 },
    (_, i) => currentDate.getFullYear() - i
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h5 style={{ margin: 0 }}>Payroll Details</h5>

        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Year */}
          <Form.Select
            style={{ width: "120px", marginRight: "0.5rem" }}
            value={selectedYear}
            onChange={handleYearChange}
          >
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Form.Select>

          {/* Month */}
          <Form.Select
            style={{ width: "150px", marginRight: "0.5rem" }}
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            {monthOptions.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Form.Select>

          {/* Search Button */}
          <Button
            size="sm"
            variant="primary"
            style={{ marginRight: "0.5rem" }}
            onClick={GetRestaurantTransaction}
          >
            Search
          </Button>

          {/* Generate Payroll */}
          <Button
            size="sm"
            variant="success"
            onClick={() => setShowModal(true)}
          >
            Generate Payroll
          </Button>
        </div>
      </div>

      <PayrollTable
        data={payrolldata}
        GetRestaurantTransaction={GetRestaurantTransaction}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
      />

      <GeneratePayrollModal
        show={showModal}
        onHide={() => setShowModal(false)}
        GetRestaurantTransaction={GetRestaurantTransaction}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
      />
    </div>
  );
};
export const AddEmployeeModal = ({
  show,
  handleClose,
  onSave,
  fetchemployeedata,
}) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;
  const shiftOptions = [
    { value: "", label: "Select Shift" },
    { value: "Morning", label: "Morning" },
    { value: "Evening", label: "Evening" },
    { value: "Night", label: "Night" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    designation: "",
    joining_date: "",
    dob: "",
    restaurant_id: null,
    shift: "",
    bank_name: "",
    bank_accno: "",
    bank_ifsc: "",
    adhaar_url: "",
    pan_url: "",
    qualification_url: "",
    profile_url: "",
  });

  const [errors, setErrors] = useState({});
  const [shopData, setShopData] = useState([]);

  const validateEmployeeForm = (data) => {
    const errors = {};
    const requiredFields = {
      name: "Name is required",
      mobile: "Mobile number is required",
      email: "Email is required",
      designation: "Designation is required",
      joining_date: "Joining date is required",
      dob: "Date of birth is required",
      restaurant_id: "Restaurant is required",
      shift: "Shift is required",
      bank_name: "Bank name is required",
      bank_accno: "Bank account number is required",
      bank_ifsc: "Bank IFSC code is required",
    };

    for (const field in requiredFields) {
      if (
        !data[field] ||
        (typeof data[field] === "string" && data[field].trim() === "") ||
        (field === "restaurant_id" && data.restaurant_id === null)
      ) {
        errors[field] = requiredFields[field];
      }
    }

    const mobileRegex = /^[6-9]\d{9}$/;
    if (data.mobile && !mobileRegex.test(data.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (data.email && !emailRegex.test(data.email)) {
      errors.email = "Enter a valid email address";
    }

    const accNoRegex = /^\d{9,18}$/;
    if (data.bank_accno && !accNoRegex.test(data.bank_accno)) {
      errors.bank_accno = "Enter a valid bank account number (9-18 digits)";
    }

    const ifscRegex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
    if (data.bank_ifsc && !ifscRegex.test(data.bank_ifsc)) {
      errors.bank_ifsc = "Enter a valid IFSC code";
    }

    return errors;
  };

  const validateForm = () => {
    const validationErrors = validateEmployeeForm(formData);
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  useEffect(() => {
    if (show) {
      fetchShopData();
      setErrors({});
      setFormData({
        name: "",
        mobile: "",
        email: "",
        designation: "",
        joining_date: "",
        dob: "",
        restaurant_id: null,
        shift: "",
        bank_name: "",
        bank_accno: "",
        bank_ifsc: "",
        adhaar_url: "",
        pan_url: "",
        qualification_url: "",
        profile_url: "",
      });
    }
  }, [show]);

  const fetchShopData = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setShopData(data.data);
      } else {
        console.error("Failed to fetch shop data", data);
      }
    } catch (error) {
      console.error("Error fetching shop data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRestaurantChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, restaurant_id: selectedOption }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const payload = {
        ...formData,
        restaurant_id: formData.restaurant_id?.value ?? null,
        firmid: user.firm_id,
      };

      const raw = JSON.stringify(payload);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/AddConractualEmployee`,
        requestOptions
      );

      if (res.ok) {
        swal("Success", "Employee saved successfully.", "success");
        onSave?.();
        handleClose();
        fetchemployeedata();
      } else {
        swal("Error", "Failed to save employee.", "error");
      }
    } catch (error) {
      swal("Error", "Something went wrong while saving employee.", "error");
      console.error("API Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const restaurantOptions = shopData.map((shop) => ({
    value: shop.id,
    label: `${shop.shop_name} (${shop.shop_location})`,
  }));
  const [isVerifyingBank, setIsVerifyingBank] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const handleVerification = async () => {
    setIsVerifyingBank(true);
    const { bank_accno, bank_ifsc } = formData;

    if (!bank_accno || !bank_ifsc) {
      setErrors({
        bank_ifsc: !bank_ifsc ? "IFSC Code is required" : "",
        bank_accno: !bank_accno ? "Account number is required" : "",
      });
      setIsVerifyingBank(false);
      return;
    }

    const requestData = {
      bank_acc_no: bank_accno,
      bank_ifsc_code: bank_ifsc,
      refrence_id: uniqueID(),
    };

    const auth = btoa("admin@billpunch.com:Billpunch@12345");

    try {
      const response = await fetch(
        "https://apiservices.bumppypay.com/api/Verification/bankVerification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${auth}`,
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();

      if (data && data.responseCode === "00") {
        setIsVerified(true);
        setVerificationMessage(
          `Successfully verified as: ${data.data.bank_holder_name}`
        );
      } else {
        setVerificationMessage("");
      }
    } catch (error) {
      console.error("Error verifying bank details:", error);
      setVerificationMessage("");
    } finally {
      setIsVerifyingBank(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={handleSubmit}>
          <Row>
            {/* Name */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter employee name"
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Mobile */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="mobile">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter mobile number"
                  isInvalid={!!errors.mobile}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobile}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Email */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Designation */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="designation">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  placeholder="Enter designation"
                  isInvalid={!!errors.designation}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.designation}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Joining Date */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="joining_date">
                <Form.Label>Joining Date</Form.Label>
                <Form.Control
                  type="date"
                  name="joining_date"
                  value={formData.joining_date}
                  onChange={handleChange}
                  isInvalid={!!errors.joining_date}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.joining_date}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* DOB */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="dob">
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  isInvalid={!!errors.dob}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.dob}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Restaurant Select */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="restaurant_id">
                <Form.Label>Restaurant</Form.Label>
                <Select
                  options={restaurantOptions}
                  value={formData.restaurant_id}
                  onChange={handleRestaurantChange}
                  placeholder="Select Restaurant"
                  className={errors.restaurant_id ? "is-invalid" : ""}
                />
                {errors.restaurant_id && (
                  <div className="invalid-feedback d-block">
                    {errors.restaurant_id}
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="shift">
                <Form.Label>Shift</Form.Label>
                <Form.Select
                  name="shift"
                  value={formData.shift}
                  onChange={handleChange}
                  isInvalid={!!errors.shift}
                >
                  {shiftOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.shift}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Row className="">
              <Col md={4}>
                <Form.Group controlId="bank_name">
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    name="bank_name"
                    value={formData.bank_name}
                    onChange={handleChange}
                    placeholder="Enter bank name"
                    isInvalid={!!errors.bank_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bank_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4} className="px-1">
                <Form.Group controlId="bank_accno">
                  <Form.Label>Bank Account No.</Form.Label>
                  <Form.Control
                    name="bank_accno"
                    value={formData.bank_accno}
                    onChange={handleChange}
                    placeholder="Enter bank account number"
                    isInvalid={!!errors.bank_accno}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bank_accno}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="bank_ifsc">
                  <Form.Label>Bank IFSC</Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      name="bank_ifsc"
                      value={formData.bank_ifsc}
                      onChange={handleChange}
                      placeholder="Enter bank IFSC code"
                      isInvalid={!!errors.bank_ifsc}
                    />
                    <Button
                      className="ms-2"
                      size="sm"
                      onClick={handleVerification}
                      disabled={isVerifyingBank}
                    >
                      {isVerifyingBank ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          Verifying...
                        </>
                      ) : (
                        "Verify"
                      )}
                    </Button>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.bank_ifsc}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            {verificationMessage && (
              <div className="text-success m-2" style={{ fontSize: ".9rem" }}>
                {verificationMessage}
              </div>
            )}
            <Col md={6} className="mb-2">
              <Form.Group controlId="adhaar_url">
                <Form.Label>Upload Adhaar Document</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({ ...prev, adhaar_url: file.name }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.adhaar_url && `Uploaded: ${formData.adhaar_url}`}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="pan_url">
                <Form.Label>Upload PAN Document</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({ ...prev, pan_url: file.name }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.pan_url && `Uploaded: ${formData.pan_url}`}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="qualification_url">
                <Form.Label>Upload Qualification Document</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({
                      ...prev,
                      qualification_url: file.name,
                    }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.qualification_url &&
                    `Uploaded: ${formData.qualification_url}`}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="profile_url">
                <Form.Label>Upload Profile Picture</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({
                      ...prev,
                      profile_url: file.name,
                    }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.profile_url && `Uploaded: ${formData.profile_url}`}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <div className="text-end mt-3">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Employee
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const Employeetable = ({ employeedata ,Fetchemployeedata}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleEdit = (emp) => {
    console.log(emp);
    setSelectedEmployee(emp);
    setShowModal(true);
  };

  const handleSave = (updatedEmp) => {
    console.log("Updated Employee:", updatedEmp);
    // Here you can update your state or call API
  };
  return (
    <>
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Name
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Mobile / Email
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Designation
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Joining Date
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              DOB
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Shop Name
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Shift
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Bank
            </th>
            <th
              className="text-center"
              style={{ color: "#0074D9", background: "#fff", border: "none" }}
            >
              Action
            </th>{" "}
            {/* New column */}
          </tr>
        </thead>
        <tbody>
          {employeedata.map((emp, index) => (
            <tr key={emp.id || index}>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.name}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.mobile}
                <br />
                {emp.email}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.designation}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.joining_date?.split("T")[0]}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.dob?.split("T")[0]}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.shop_name}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".9rem" }}
              >
                {emp.shift}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none", fontSize: ".8rem" }}
              >
                {emp.bank_name}
                <br />
                {emp.bank_accno}
                <br /> {emp.bank_ifsc}
              </td>
              <td
                className="text-center align-middle"
                style={{ border: "none" }}
                onClick={() => handleEdit(emp)}
              >
                <img alt="Edit" src={editIcon} style={{ width: "3rem" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <EmployecontracteeditModal
  show={showModal}
  onHide={() => setShowModal(false)}
  employee={selectedEmployee}
  onSave={handleSave}
  Fetchemployeedata={Fetchemployeedata}
/>

    </>
  );
};
export const PayrollTable = ({ data, GetRestaurantTransaction ,  selectedMonth,selectedYear}) => {
  const { password, username } = billpunchbasicauth;
  const [clickedRows, setClickedRows] = useState([]);
  const [rows, setRows] = useState(data);
  const [viewModalShow, setViewModalShow] = useState(false);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedServiceType, setSelectedServiceType] = useState({});
  useEffect(() => {
    setRows(data);
  }, [data]);
  const handleProcessAll = async (
    fk_empid,
    amount,
    bank_accno,
    bank_ifsc,
    bank_name,
    mobile,
    name,
    month
  ) => {
    setTransactionLoaderState(true);

    let transactionMode = selectedServiceType?.[fk_empid] || "IMPS";

    if (clickedRows.includes(fk_empid)) {
      swal("Error", "Button already clicked for this row", "error");
      return;
    }

    const sanitize = (value) =>
      typeof value === "string" ? value.trim() : value;

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const payload = {
        id: fk_empid.toString(),
        firmid: user.firm_id,
        purpose: "RESTSALARY",
        userid: fk_empid.toString(),
        amount: amount.toString(),
        tpin: "1",
        serviceType: transactionMode,
        accNo: sanitize(bank_accno),
        ifsc: sanitize(bank_ifsc),
        bankName: sanitize(bank_name),
        mobile,
        custName: name,
        month,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/SalaryManagement/ChaafoPayroll`,
        requestOptions
      );

      const result = await response.json();
      if (result.status === "0") {
        swal("Success", result.msg, "success");
        setRows((prev) =>
          prev.map((row) =>
            row.fk_empid === fk_empid ? { ...row, status: "Success" } : row
          )
        );
        await GetRestaurantTransaction(selectedMonth, selectedYear);

      } else {
        swal("Error", result.msg, "error");
        setRows((prev) =>
          prev.map((row) =>
            row.fk_empid === fk_empid ? { ...row, status: "Failed" } : row
          )
        );
        await GetRestaurantTransaction(selectedMonth, selectedYear);

      }

      setTransactionLoaderState(false);
      setClickedRows((prev) => [...prev, fk_empid]);
    } catch (error) {
      swal("API call failed", "An error occurred", "error");
      setTransactionLoaderState(false);
    }
  };
  const handleViewButtonClick = (item) => {
    setSelectedRowData(item);
    setViewModalShow(true);
  };

  return (
    <>
      <Viewmodalcontractpayslip
        show={viewModalShow}
        handleClose={() => setViewModalShow(false)}
        data={selectedRowData}
      />
      <Table bordered hover size="sm">
        <thead>
          <tr>
            <th className="text-center">Employee</th>
            <th className="text-center">Mobile</th>
            <th className="text-center">Designation</th>
            <th className="text-center">Shop Name <br></br>Shop Location</th>
            {/* <th className="text-center">Shop Location</th> */}
            <th className="text-center">Bank</th>
            <th className="text-center">Pay Days</th>
            <th className="text-center">Amount</th>
            <th className="text-center">Status</th>
            <th className="text-center">Pay</th>
            <th className="text-center">Slip</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((item) => (
              <tr key={item.fk_empid + item.from_date}>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.name}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.mobile}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.designation}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.shop_name}<br/>     {item.shop_location}
                </td>
                {/* <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.shop_location}
                </td> */}
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.bank_name}
                  <br /> {item.bank_accno}
                  <br /> {item.bank_ifsc}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.pay_days}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.amount}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ fontSize: ".9rem" }}
                >
                  {item.status === "P" ? (
                    <span className="p-1" style={{ color: "#f7b12a" }}>
                      Pending
                    </span>
                  ) : (
                    item.status
                  )}
                </td>
                <td className="text-center align-middle">
                  {item.status === "P" ? (
                    <Button
                      size="sm"
                      onClick={() =>
                        handleProcessAll(
                          item.id,
                          item.amount,
                          item.bank_accno,
                          item.bank_ifsc,
                          item.bank_name,
                          item.mobile,
                          item.name,
                          item.month
                        )
                      }
                      disabled={item.hold_status === "Y"}
                    >
                      Process
                    </Button>
                  ) : (
                    <Button size="sm" disabled>
                      Processed
                    </Button>
                  )}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ border: "none", fontSize: ".8rem" }}
                >
                  <div className="d-flex align-items-center">
                    <Link
                      style={{ marginRight: "5px" }}
                      className="tooltip-container"
                    >
                      <img
                        alt=""
                        src={slip}
                        onClick={() => handleViewButtonClick(item)}
                      />
                    </Link>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="14" style={{ textAlign: "center" }}>
                No payroll data found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
export const ShopTable = ({ shopData }) => {
  return (
    <Table bordered hover responsive>
      <thead>
        <tr>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Shop Name
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Location
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Shop Mobile
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Owner Name
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Owner Mobile
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            GST
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Type
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Pincode
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Details
          </th>
        </tr>
      </thead>
      <tbody>
        {shopData.map((shop, index) => (
          <tr key={shop.id || index}>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_name}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_location}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_mobile}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.owner_name}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.owner_mobile}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_gst}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_type}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_pincode}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_details}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
export default Contracthr;
